<script setup>
import { computed } from '#imports';

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
  isLight: {
    type: Boolean,
    default: false,
  },
});

const formattedDate = computed(() =>
  new Date(props.date).toLocaleString('ru-RU', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
);
</script>

<template>
  <div class="published-date" :class="{ 'published-date--light': isLight }">
    <div class="published-date__caption">Публикация</div>
    <div class="published-date__value">{{ formattedDate }}</div>
  </div>
</template>

<style lang="postcss" scoped>
.published-date {
  &__caption {
    font-size: 14px;
    line-height: 22px;
    color: rgba(var(--black-color--rgb), 40%);
  }

  &__value {
    font-size: 18px;
    line-height: 26px;
  }

  &--light {
    .published-date__caption {
      color: rgba(var(--white-color--rgb), 40%);
    }

    .published-date__value {
      color: var(--white-color);
    }
  }

  @media (--small-vp) {
    &__caption {
      font-size: 12px;
      line-height: 15px;
    }

    &__value {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
